import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import style from './Home.module.css'
import { useState } from 'react';
import { Button } from '../../components';
import { useEffect } from 'react';
import Prepare from '../Prepare/Prepare';
import Quiz from '../Quiz/Quiz';
import { useGetQuestionsQuery } from '../../redux/questionsApi';

const Home = () => {

    const navigate = useNavigate();

    const [input, setInput] = useState('');
    const [alert, setAlert] = useState(false);

    const [step, setStep] = useState(1)

    const invalidNames = ["acido", "alcohol", "banco", "bancos", "berreta", "birra", "boluda", "bolude", "bolude", "boludeo", "boludo", "boludo", "bulto", "cachucha", "cachuche", "camuca", "cerveza", "chanta", "chonga", "chongo", "chorra", "chorre", "chorro", "chupala", "chupame", "chupamela", "cocaina", "coger", "cogerse", "cogida", "cogide", "cogido", "coima", "concha", "conche", "conchuda", "conchude", "conchudo", "cornuda", "cornude", "cornudo", "cule", "culeada", "culeade", "culeado", "culo", "culon", "culona", "culone", "de la gorra", "diarrea", "drogas", "escabio", "estupida", "estupide", "estupido", "facho", "fernet", "fernetcola", "forra", "forro	forre", "gato", "gede", "gin", "gin tonic", "gorde", "gordo", "guaso", "hede", "imbecil", "imberbe", "joder", "kilombo", "kirchner", "lsd", "macri", "macri", "mala leche", "manca", "manco", "manque", "marihuana", "merca", "mersa", "mierda", "milico", "minita", "mucama", "muerta", "muerto", "orte", "ortiva", "orto", "partusa", "pastillas", "pecho frio", "pelotuda", "pelotude", "pelotudo", "pendeja", "pendeje", "pendejo", "pene", "pibes chorros", "pija", "pije", "pijita", "pijite", "pijon", "pijude", "pijudo", "politicos", "poronga", "porongon", "poronguita", "puta", "puta", "pute", "pute", "puteada", "putear", "putita", "putit", "putito", "puto", "putos", "quilombo", "rengo", "santander", "sorete", "teta", "tete", "tetona", "teton", "tonta", "tonte", "tonto", "trucha", "trucho", "vino", "yuta"]
    const invalidNamesPlural = ["acidos", "alcohols", "bancos", "bancoss", "berretas", "birras", "boludas", "boludes", "boludes", "boludeos", "boludos", "boludos", "bultos", "cachuchas", "cachuches", "camucas", "cervezas", "chantas", "chongas", "chongos", "chorras", "chorres", "chorros", "chupalas", "chupames", "chupamelas", "cocainas", "cogers", "cogerses", "cogidas", "cogides", "cogidos", "coimas", "conchas", "conches", "conchudas", "conchudes", "conchudos", "cornudas", "cornudes", "cornudos", "cules", "culeadas", "culeades", "culeados", "culos", "culons", "culonas", "culones", "de la gorras", "diarreas", "drogass", "escabios", "estupidas", "estupides", "estupidos", "fachos", "fernets", "fernetcolas", "forras", "forro	forres", "gatos", "gedes", "gins", "gin tonics", "gordes", "gordos", "guasos", "hedes", "imbecils", "imberbes", "joders", "kilombos", "kirchners", "lsds", "macris", "macris", "mala leches", "mancas", "mancos", "manques", "marihuanas", "mercas", "mersas", "mierdas", "milicos", "minitas", "mucamas", "muertas", "muertos", "ortes", "ortivas", "ortos", "partusas", "pastillass", "pecho frios", "pelotudas", "pelotudes", "pelotudos","pendejas", "pendejes", "pendejos", "penes", "pibes chorross", "pijas", "pijes", "pijitas", "pijites", "pijons", "pijudes", "pijudos", "politicoss", "porongas", "porongons", "poronguitas", "putas", "putas", "putes", "putes", "puteadas", "putears", "putitas", "putits", "putitos", "putos", "putoss", "quilombos", "rengos", "santanders", "soretes", "tetas", "tetes", "tetonas", "tetons", "tontas", "tontes", "tontos", "truchas", "truchos", "vinos", "yutas"]

    const inputArray = input?.split("");

    const goNext = () => {
        if (!checkNameAndSaveToLocalStorage()) {
            setStep(2)
        }
    }

    const checkNameAndSaveToLocalStorage = () => {
        let resultado = false;

        for (let i = 0; i < inputArray.length; i++) {

            if (invalidNames.includes(inputArray[i].toLowerCase().replace(/(.)\1+/g, '$1')) || invalidNamesPlural.includes(inputArray[i].toLowerCase().replace(/(.)\1+/g, '$1'))) {
                resultado = true;
                setAlert(true)
            } else {
                localStorage.setItem('name', JSON.stringify(input));
                resultado = false;
                setAlert(false)
            }
        }
        return resultado;
    }

    localStorage.clear();

    const [questions, setQuestions] = useState([]);
    const { data, isFetching } = useGetQuestionsQuery();

    useEffect(() => {
        if(!isFetching) {
            setQuestions(Object.values(data));
        }
    }, [data, isFetching]);

    return (
        <div>
            {
                step === 1 ? 
                <>
                    <h1 className={style.title}>Desafiá tus conocimientos</h1>
                    <div className={style.quiz_container}>
                        <input className={style.name} value={input} onInput={e => setInput(e.target.value)} placeholder='Escribi tu nombre para empezar'></input>
                        <span className={style.alertName} data-disabled={alert}>Por favor, elegí otro nombre</span>
                        <div className={style.start}>
                            <Button text='Siguiente' onClick={input.length > 0 ? goNext : null} disabled={input.length > 0 ? false : true} />
                        </div> 
                        <Link className={style.ranking} to='/ranking'>Ver ranking</Link>
                    </div>
                </>
                :
                <>
                </>
            }
            {
                step === 2 ? <Prepare nameToDisplay={input} setStep={setStep}/> : <></>
            }
            {
                step === 3 ? <Quiz nameToDisplay={input} propsQuestions={questions}/> : <></>
            }
            
        </div>
    )
}

export default Home